import React, { useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import Swal from "sweetalert2";

function CourseContent({ courseData }) {
  // const [testimonialIndex, setTestimonialIndex] = useState(0);
  // const testimonialStartX = useRef(null);
  const AWS = process.env.REACT_APP_AWS_HOST;
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [viewed, setViewed] = useState(false);
  const [showFallback, setShowFallback] = useState(false)

  if (!courseData?.course) {
    return (
      <div className="col-md-8">
        <div className="card">
          <div className="card-body text-center py-5">
            <i className="ri-error-warning-line text-warning display-4 mb-3"></i>
            <h4 className="text-dark mb-3">Course Content Unavailable</h4>
            <p className="text-muted mb-4">
              We couldn't load the course content at this moment. This could be because:
            </p>
            <ul className="list-unstyled text-muted">
              <li>The course may have been removed or relocated</li>
              <li>There might be a temporary server issue</li>
              <li>The course data might be still loading</li>
            </ul>
            <button
              className="btn btn-primary mt-3"
              onClick={() => window.location.reload()}
            >
              <i className="ri-refresh-line me-1"></i> Refresh Page
            </button>
          </div>
        </div>
      </div>
    );
  }

  const { course } = courseData;

  // Reorder tabs to show Lessons first, then About The Course
  const orderedTabs = course.tabs.sort((a, b) => {
    if (a.tab === "Lessons") return -1;
    if (b.tab === "Lessons") return 1;
    if (a.tab === "About The Course") return -1;
    if (b.tab === "About The Course") return 1;
    return 0;
  });

  const handleVideoEnded = () => {
    if (!viewed) {
      console.log('Video ended, could auto-mark as viewed');
    }
    setIsPlaying(false); // Update play state
  };

  const handlePlayClick = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };

  const size = isMobile ? 58 : 77;
  const iconSize = isMobile ? 30 : 55;


  return (
    <div className="col-md-8">
      {courseData.preview_video && !courseData.preview_video.includes('/mod') && !courseData.preview_video.includes('\\mod') && !courseData.preview_video.includes('\mod') && (
        <div className="card">
          <div className="card-body p-0">
            <div className="position-relative">
              <video
                ref={videoRef}
                className="w-100"
                src={`${AWS}${courseData.preview_video}`}
                controls
                autoPlay
                muted
                controlsList="nodownload"
                style={{
                  maxHeight: "400px",
                  objectFit: "cover",
                  borderTopLeftRadius: "var(--bs-card-border-radius)",
                  borderTopRightRadius: "var(--bs-card-border-radius)"
                }}
                // poster={course.thumbnail || `${AWS}${course.image}`}
                onContextMenu={(e) => e.preventDefault()}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  setShowFallback(true);
                }}
                onEnded={handleVideoEnded}
                onPlay={handleVideoPlay}
                onPause={handleVideoPause}
              >
                <source src={`${AWS}${courseData.preview_video}`} />
                Your browser does not support the video tag.
              </video>
              {!isPlaying && (
                <div
                  className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center"
                  style={{
                    cursor: 'pointer',
                    background: '#ffca5ba6',
                    borderRadius: '50%',
                    width: `${size}px`,
                    height: `${size}px`,
                    paddingLeft: 5,
                    pointerEvents: 'auto'
                  }}
                  onClick={handlePlayClick}
                >
                  <i
                    className="ri-play-fill"
                    style={{
                      fontSize: `${iconSize}px`,
                      color: '#fff',
                      lineHeight: 1,
                    }}
                  ></i>
                </div>
              )}
              {showFallback && (
                <div className="w-100 h-100 d-flex rounded align-items-center justify-content-center bg-dark text-white">
                  <p>⚠️ Video not available</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="card">
        <div className="card-header">
          <h4 className="mb-0">Course content</h4>
        </div>
        <div className="card-body">
          <ul className="nav nav-pills arrow-navtabs nav-success bg-light mb-3" role="tablist">
            {orderedTabs.map((tab, idx) => (
              <li className="nav-item" key={tab.tab}>
                <a className={`nav-link${idx === 0 ? " active" : ""}`} data-bs-toggle="tab" href={`#tab-${idx}`} role="tab">
                  <span className="d-block d-sm-none" style={{ fontSize: "11px" }}>{tab.tab}</span>
                  <span className="d-none d-sm-block fs-5">{tab.tab}</span>
                </a>
              </li>
            ))}
          </ul>
          <div className="tab-content text-muted">
            {orderedTabs.map((tab, idx) => (
              <div className={`tab-pane${idx === 0 ? " active" : ""}`} id={`tab-${idx}`} role="tabpanel" key={tab.tab}>
                {tab.tab === "About The Course" && (
                  <>
                    <h5
                      className="mb-3 fs-15 lh-base mb-0"
                      dangerouslySetInnerHTML={{
                        __html: tab.content.learningObjectives || 'Description is Not Available'
                      }}
                    ></h5>
                  </>
                )}
                {tab.tab === "Lessons" && (
                  <div className="accordion custom-accordionwithicon accordion-fill-success" id="accordionFill">
                    {tab.content.modules.map((module, mIdx) => (
                      <div
                        className="accordion-item shadow-sm rounded mb-2"
                        key={module.title}
                      >
                        <h2 className="accordion-header p-2" id={`accordionFillExample${mIdx + 1}`} >
                          <button
                            className={`accordion-button fw-semibold${mIdx !== 0 && !module.expanded ? " collapsed" : ""}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#accor_fill${mIdx + 1}`}
                            aria-expanded={mIdx === 0 ? true : module.expanded}
                            aria-controls={`accor_fill${mIdx + 1}`}
                            style={{ paddingLeft: '15px', paddingRight: '15px' }}
                          >
                            <i className="ri-folder-line me-2"></i>
                            {module.title}
                          </button>
                        </h2>
                        <div
                          id={`accor_fill${mIdx + 1}`}
                          className={`accordion-collapse collapse${mIdx === 0 || module.expanded ? " show" : ""}`}
                          aria-labelledby={`accordionFillExample${mIdx + 1}`}
                          data-bs-parent="#accordionFill"
                        >
                          <div className="accordion-body">
                            <div className="list-group list-group-fill-success">
                              {module.chapters && module.chapters.length > 0 ? (
                                module.chapters.map((chapter, tIdx) => (
                                  <div
                                    className="list-group-item list-group-item-action border-0 rounded hover-shadow"
                                    key={chapter.chapter_title}
                                    onClick={() => {
                                      if (isMobile) {
                                        setTimeout(() => {
                                          window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                                        }, 0);
                                      }

                                      Swal.fire({
                                        icon: 'warning',
                                        title: '',
                                        text: 'Please enroll in the course to view the content.',
                                        confirmButtonColor: '#eee127ff',
                                        confirmButtonText: 'OK'
                                      });
                                    }}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center">
                                        <i className="ri-play-circle-line fs-4 text-success me-2"></i>
                                        <span className="fw-medium">{chapter.chapter_title}</span>
                                      </div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="text-muted text-center py-3">
                                  <i className="ri-book-open-line fs-1 mb-2 d-block text-primary"></i>
                                  <h6 className="mb-1">Module: {module.title}</h6>
                                  <p className="mb-0 small">Detailed content will be available once you enroll in the course.</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {tab.tab === "Curated by" && (
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex position-relative">
                        <img
                          src={`${AWS}${tab.content.faculty_img}` || `https://ui-avatars.com/api/?name=${tab.content.faculty_name.split(' ').join('+')}&background=random`}
                          className="flex-shrink-0 me-3 rounded"
                          alt={tab.content.faculty_name || "Faculty"}
                          style={{ width: "68px", height: "68px", objectFit: "cover" }}
                        />
                        <div>
                          <h5 className="mt-0">{tab.content.faculty_name}</h5>
                          <p>{tab.content.description}</p>
                        </div>
                      </div>
                      {/* <div className="d-flex flex-column gap-3">
                        {courseData.teachers.map((teacher, index) => (
                          <div className="d-flex position-relative" key={index}>
                            <img 
                              src={`${AWS}${teacher.profile_image}` || `https://ui-avatars.com/api/?name=${teacher.first_name}+${teacher.last_name}&background=random`}
                              className="flex-shrink-0 me-3 rounded" 
                              alt={`${teacher.first_name} ${teacher.last_name}` || "Faculty"}
                              style={{ width: "68px", height: "68px", objectFit: "cover" }}
                            />
                            <div>
                              <h5 className="mt-0">{`${teacher.first_name} ${teacher.last_name}`}</h5>
                            </div>
                          </div>
                        ))}
                      </div> */}
                    </div>
                  </div>
                )}
                {/* {tab.tab === "Testimonials" && (
                  <div className="card border-0 shadow-sm">
                    <div className="card-body p-4">
                      <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner text-center" style={{ width: "70%", margin: "0 auto"}}>
                          {tab.content.testimonials.map((testimonial, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                              <div className="d-flex flex-column align-items-center mb-4">
                                <img 
                                  src={testimonial.image} 
                                  alt={testimonial.name} 
                                  className="avatar-sm rounded-circle shadow-sm mb-2"
                                  style={{width: "48px", height: "48px", objectFit: "cover"}}
                                />
                                <h5 className="card-title fw-semibold mb-1">{testimonial.name}</h5>
                                <p className="text-muted small mb-0">{testimonial.grade}</p>
                              </div>
                              <div className="testimonial-content">
                                <i className="ri-double-quotes-l text-primary fs-1 mb-2"></i>
                                <p className="card-text fs-5 text-muted fst-italic">{testimonial.text}</p>
                                <i className="ri-double-quotes-r text-primary fs-1 mb-2"></i>
                              </div>
                            </div>
                          ))}
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                          <span className="carousel-control-prev-icon bg-dark rounded-circle p-2" aria-hidden="true"></span>
                          <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                          <span className="carousel-control-next-icon bg-dark rounded-circle p-2" aria-hidden="true"></span>
                          <span className="visually-hidden">Next</span>
                        </button>
                        <div className="carousel-indicators position-relative mt-4">
                          {tab.content.testimonials.map((_, index) => (
                            <button
                              key={index}
                              type="button"
                              data-bs-target="#testimonialCarousel"
                              data-bs-slide-to={index}
                              className={index === 0 ? "active" : ""}
                              aria-current={index === 0 ? "true" : "false"}
                              aria-label={`Slide ${index + 1}`}
                            ></button>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseContent;